module.exports = __webpack_public_path__ + "img/youtube.c5147ffe.svg";